module.exports = __webpack_public_path__ + "static/media/translations1.39137fb7.jpg";